import React, { Suspense } from "react";
import { LoadingSection } from "../UI/Loading/Loading";
import { Switch } from "react-router-dom";

export default ({ children }) => {
  return (
    <Suspense fallback={<LoadingSection />}>
      <Switch>{children}</Switch>
    </Suspense>
  );
};
